import styled from 'styled-components';
import { ContainerType } from '../../../types';

export const StyledGroupContainer = styled.div`
  display: block;
  width: 100%;
`;

export const StyledGroupParenthesisContainer = styled.div<{ containerType: ContainerType }>`
  margin-top: ${({ containerType }) => (containerType === ContainerType.ISLAND ? '2px' : '0px')};
`;
